module.exports = __webpack_public_path__ + "static/sm_img03_m@2x-469a292548b465275e46237a029b7570.jpg";